module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[112]233.372708d.woff2";